import { register } from '../../../Utils'

const TestComponent = el => {
  console.log('compiled test component')
}

register('TestComponent', TestComponent)
